export default "__VITE_ASSET__09945bd6__"